import { render } from "./DecisionIcon.vue?vue&type=template&id=2a664632&scoped=true"
import script from "./DecisionIcon.vue?vue&type=script&lang=js"
export * from "./DecisionIcon.vue?vue&type=script&lang=js"

import "./DecisionIcon.vue?vue&type=style&index=0&id=2a664632&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a664632"]])

export default __exports__